/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'other': {
    width: 52,
    height: 29,
    viewBox: '0 0 52 29',
    data: '<path pid="0" class="st0" d="M32.2 26.9c1.8.8 3.7 1.2 5.6 1.2 7.8 0 14.1-6.3 14.1-14.1 0-7.7-6.3-14-14.1-14S23.7 6.3 23.7 14.1c0 5.4-4.4 9.7-9.7 9.7-5.4 0-9.7-4.4-9.7-9.7 0-5.4 4.4-9.7 9.7-9.7 1.4 0 2.7.3 3.9.8 1.1.5 2.4 0 2.8-1.1.5-1.1 0-2.4-1.1-2.8C17.9.4 16 0 14.1 0 6.3 0 0 6.3 0 14.1s6.3 14.1 14.1 14.1 14.1-6.3 14.1-14.1c0-5.4 4.4-9.7 9.7-9.7 5.4 0 9.7 4.4 9.7 9.7 0 5.4-4.4 9.7-9.7 9.7-1.4 0-2.7-.3-3.9-.8-1.1-.5-2.4 0-2.8 1.1s-.1 2.4 1 2.8"/>'
  }
})
